// inventoryImportApi.js — client for inventory IMPORT (CSV/XLSX + AI scan).
import ApiCall from "./apicall";

export async function parseInventoryFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await ApiCall.post("/inventory/import/parse", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data?.data;
}

export async function scanReceivingDoc(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await ApiCall.post("/inventory/import/scan", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data?.data;
}

export async function commitInventoryImport(items) {
  const res = await ApiCall.post("/inventory/import/commit", { items });
  return res?.data?.data;
}

export const INVENTORY_CATEGORIES = [
  { value: "steel_stock", label: "Steel Stock" },
  { value: "consumables", label: "Consumables" },
  { value: "gas", label: "Gas" },
  { value: "safety_ppe", label: "Safety / PPE" },
  { value: "tools_equipment", label: "Tools / Equipment" },
  { value: "hardware", label: "Hardware" },
  { value: "coatings_paint", label: "Coatings / Paint" },
  { value: "other", label: "Other" },
];
